<template>
    <Frame>
        <PageHeader :title="$t('comm.bulletin')" :hasBack="true" />
        <div>
            <div class="search-row">
                <div>
                    <span class="label">{{ $t('BulletinCenter.keyword') }}:</span><el-input size="small" v-model="searchinput"
                    :placeholder="$t('BulletinCenter.inputpls')" clearable></el-input>
                </div>
                <div>
                    <el-button @click="resetInput" plain>{{ $t('button.reset') }}</el-button>
                    <el-button @click="search(0)" type="primary">{{ $t('button.search') }}</el-button>
                </div>
            
            </div>
            <div class="download-form">
                <el-table :data="tableData" style="width: 100%" :height="tableHeight" v-loading="loading">
                    <el-table-column prop="name" :label="$t('BulletinCenter.maintitle')">
                        <template slot-scope="scope">
                            <el-link :underline="false" index="/Home/BulletinCenter/BulletinCenterDetail"
                                @click="viewDetail(scope.$index, scope.row)">
                                {{ scope.row.name}}
                            </el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="date" :label="$t('Download.date')">
                    </el-table-column>
                    <el-table-column prop="option" :label="$t('HelpCenter.operation')" width="100">
                        <template slot-scope="scope">
                            <el-link :underline="false" index="/Home/BulletinCenter/BulletinCenterDetail"
                                @click="viewDetail(scope.$index, scope.row)" type="primary">
                                {{ $t('button.check')}}
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination style="padding-left:50%;width:50%;" @current-change="handleCurrentChange"
                    layout="total,prev,pager,next,jumper" :pager-count="5" :current-page="currentPage"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
    </Frame>
</template>

<script>
export default {
    name: "HelpCenter",
    data() {
        return {
            tableData: [],
            searchinput: '',
            loading: false,
            totalCount: 0,
            currentPage: 1,
            pageindex: 0,
            tableHeight: window.innerHeight - 312,
        }
    },
    created() {
        this.search(0);
    },
    beforeRouteLeave(to,from,next){
        //跳转到详情页时，不销毁清单页
        if(to.path == `/Home/${from.name}Detail`){
            from.meta.keepAlive = true;
        }else{
            from.meta.keepAlive = false;
        }
        next();
    },
    mounted() {
        let that = this
        window.onresize = () => {
            if (that.resizeFlag) {
                clearTimeout(that.resizeFlag);
            }
            that.resizeFlag = setTimeout(() => {
                that.tableHeight = window.innerHeight - 312;
                that.resizeFlag = null;
            }, 100);
        }
    },
    methods: {
        resetInput() {
            this.value = "";
            this.searchinput = "";
            this.search(0);
        },
        search(pageindex) {
            //搜索按钮的方法
            this.currentPage = pageindex + 1;
            this.loading = true;
            this.axiosInvoke("/"+localStorage.getItem('PlatformPath')+"/Handler/VueSysHandler.ashx", {
                action: "getbulletin",
                keyword: this.searchinput,
                typeId: "sysbulletin",
                pageindex: pageindex,
                pagesize: 10
            }, (res) => {
                //console.log(res.data);
                var data = res.data;
                this.totalCount = data[0].totalCount;
                data.shift(0);
                this.tableData = data;
                this.loading = false;
                console.log(data);
            })
            //this.searchinput  输入框的内容 this.value 选择框的内容
        },
        viewDetail(index, row) {
            sessionStorage.setItem("BulletinCenter", JSON.stringify({
                value: this.value,
                searchinput: this.searchinput,
                pageindex: this.pageindex
            }))
            this.$router.push({
                path: "/Home/BulletinCenterDetail",
                query: {
                    Title: row.name,
                    BillNo: row.BillNo,
                }
            })
            console.log(index, row)//index 行号 row 行内容
        },
        handleCurrentChange(val) {
            this.pageindex = val - 1;
            this.search(val - 1);
        }
    }
}
</script>

<style scoped>
.el-container /deep/.el-main {
    padding: 0;
    margin: 0;
}


.el-input__inner {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
    margin: auto 0;
}

.el-input__inner::placeholder {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
}

.el-select .el-input {
    width: 100%;
}

.el-select {
    width: 10%;
    margin-right: 33%;
}

.label {
    margin: auto 0;
    white-space: nowrap;
    padding-right: 10px;
}


.search-row {
    height: 32px;
    margin: 1.5rem 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.search-row>div{
    display: flex;
    margin: 0 2.5%;
}
.search-row>div:first-child{
    width: 30%;
}
.search-row .el-button {
    padding: 9px 15px !important;
}

.download-form {
    width: 95%;
    padding: 20px 2.5%;
}

.pagination {
    width: 100%;
}
</style>